export default {"src":"/_next/static/media/packer-logo-mark_on-light.46a83879.svg","height":72,"width":35,"blurWidth":0,"blurHeight":0};